import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import React from 'react';

const TYDatePicker = (props) => {
    const [value, setValue] = React.useState(null);

    React.useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    React.useEffect(() => {
        if(props.reset !== undefined){
           setValue(null);
           props.setDate(null);
        }
    }, [props.reset]);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
                {...props}
                label={props.label}
                value={value ? dayjs(value) : null}
                minDate={props.min ? dayjs(props.min) : undefined}
                format="DD-MMM-YYYY"
                onChange={(date) => {
                    if (date && dayjs(date).isValid()) {
                        if (props.min && dayjs(date).isBefore(dayjs(props.min), 'day')) {
                            props.setDate(dayjs(props.min).format('YYYY-MM-DD'));
                            return;
                        }

                        props.setDate(dayjs(date).format('YYYY-MM-DD'));
                    } else {
                        props.setDate(null);
                    }
                }}
                slotProps={{
                    textField: {
                      helperText: props.errorMsg ?? '',
                      error: Boolean(props.error),
                      size: 'small',
                      placeholder: props.placeholder || 'DD-MMM-YYYY',
                      fullWidth: props.fullWidth || false
                    },
                    actionBar: {
                        actions: ['clear', 'today'],
                    },
                }}
            />
        </LocalizationProvider>
    )
};

export default TYDatePicker;